import { getAuthMode } from '@/utils/auth/authMode';
import { getMockBearerToken } from '@/utils/auth/mockAuthSession';
import { getPathBOrgConfirmMode } from '@/utils/auth/pathBOrgConfirm';
import { authEnv } from '@/utils/config/auth';

function maskSecret(value: string): string {
  if (!value.trim()) return '(unset)';
  if (value.length <= 12) return '*** (set)';
  return `${value.slice(0, 8)}…${value.slice(-4)}`;
}

/** One-time browser console summary after the bundle loads. */
export function logRuntimeAuthConfig(): void {
  const devJwt = getMockBearerToken();
  const pool = (authEnv.userPoolId || '').trim();
  const clerkKey = (process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || '').trim();
  const apiUrl = (process.env.REACT_APP_POOLED_TENANT_API_URL || '').trim();
  const skipOnboarding = process.env.REACT_APP_SKIP_ONBOARDING_CHECK === 'true';

  const mode = getAuthMode();
  let hint: string;

  if (mode === 'clerk') {
    hint = 'Sign in via /sign-in (Clerk). API Bearer comes from Clerk getToken(). Set Clerk__Authority on the API.';
  } else if (mode === 'local-mock-jwt') {
    hint =
      'Using REACT_APP_DEV_JWT for API Bearer and session fallback (no Cognito sign-in required). Match API Cognito__UserPoolId= for dev JWT validation.';
  } else if (mode === 'aws-cognito') {
    hint = 'Sign in via /sign-in (Amplify). API Bearer comes from Cognito session tokens.';
  } else {
    hint =
      'Set REACT_APP_CLERK_PUBLISHABLE_KEY, REACT_APP_DEV_JWT, or Cognito env vars in env/.env.local.user and restart.';
  }

  console.info('[ChurnSignal] Runtime auth configuration');
  console.info('  mode:', mode);
  console.info('  APP_ENV:', process.env.APP_ENV || '(unset)');
  console.info('  REACT_APP_GIT_SHA:', process.env.REACT_APP_GIT_SHA || '(local / unset)');
  console.info('  REACT_APP_GIT_REF:', process.env.REACT_APP_GIT_REF || '(unset)');
  console.info('  REACT_APP_GITHUB_RUN_ID:', process.env.REACT_APP_GITHUB_RUN_ID || '(unset)');
  console.info('  REACT_APP_CLERK_PUBLISHABLE_KEY:', clerkKey ? maskSecret(clerkKey) : '(unset)');
  console.info('  REACT_APP_PATH_B_ORG_CONFIRM:', getPathBOrgConfirmMode());
  console.info('  REACT_APP_DEV_JWT:', maskSecret(devJwt));
  console.info('  REACT_APP_AUTH_USER_POOL_ID:', pool || '(unset)');
  console.info('  REACT_APP_POOLED_TENANT_API_URL:', apiUrl || '(unset)');
  console.info('  REACT_APP_SKIP_ONBOARDING_CHECK:', skipOnboarding);
  console.info('  →', hint);

  if (mode === 'local-mock-jwt' && pool) {
    console.warn(
      '[ChurnSignal] Both REACT_APP_DEV_JWT and Cognito pool id are set in the bundle. Dev JWT takes precedence for API calls; Cognito sign-in is optional.',
    );
  }
}
